import { render, staticRenderFns } from "./UserTransaction.vue?vue&type=template&id=16186153"
import script from "./UserTransaction.vue?vue&type=script&lang=js"
export * from "./UserTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports